(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vuetify/lib"));
	else if(typeof define === 'function' && define.amd)
		define(["vuetify/lib"], factory);
	else if(typeof exports === 'object')
		exports["vuetify-resource"] = factory(require("vuetify/lib"));
	else
		root["vuetify-resource"] = factory(root["vuetify/lib"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__4875__) {
return 